// `/accounts` sub-layout — passthrough so child routes inherit the
// `_authed` shell without an extra page chrome layer.

import { Outlet, createRoute } from '@tanstack/react-router';

import { Route as AuthedLayoutRoute } from '../__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: 'accounts',
  component: AccountsLayout,
});

function AccountsLayout() {
  return <Outlet />;
}
